'use strict';

export default class StablishmentAbout {
  constructor(options) {
    console.log('stablishmentAbout module');

    const defaults = {
      readMore: '.establishment--AAD .stablishmentAbout__text'
    };

    this.options = Object.assign({}, defaults, options);

    //exposed methods
    this.initReadMore = this._initReadMore;
  }

  _initReadMore() {
    if ($(this.options.readMore).length > 0) {
      $(this.options.readMore).readmore({
        speed: 500,
        collapsedHeight: 105,
        moreLink: '<a href="#" class="read-more__button">Lire la suite</a>',
        lessLink: '<a href="#" class="read-more__button">Lire moins</a>'
      });
    }

    return this;
  }
}
